import { MAIN_COVER_EVENTS } from "../";
import { useContext, useEffect, useRef } from "react";
import {
  useAppLocation,
  useAppNavigate,
  useAnalytics,
  makeUrl,
  resizeImage,
} from "@commons-monorepo/index";
import { ContentCoverContext } from "./main-cover.context";

export const useDataSlider = () => {
  const { config, stepToPause, storeMetadata, hasOffers, hasWholesale } =
    useContext(ContentCoverContext);
  const navigate = useAppNavigate();
  const { pathname } = useAppLocation();
  const [logEvent] = useAnalytics({ storeMetadata });
  const enterpriseName = storeMetadata?.enterpriseName;

  const items: any[] = [];
  if (config.welcome?.image.web_cover) {
    items.push({
      title: config.welcome?.text,
      imageDesktop: config.welcome.image.web_cover,
      imageMobile: config.welcome.image.cover_image,
      config: config.welcome,
      link: {
        label: config.welcome.text_button,
        elementId: "catalogue-main-products-anchor",
      },
    });
  }
  if (hasOffers) {
    items.push({
      title: config.offers?.text,
      imageDesktop: config.offers.image.web_cover,
      imageMobile: config.offers.image.cover_image,
      config: config.offers,
      link: {
        label: config.offers.text_button,
        value: makeUrl(pathname, `ofertas`),
      },
    });
  }
  if (hasWholesale) {
    items.push({
      title: config.wholesale.text,
      imageDesktop: config.wholesale.image.web_cover,
      imageMobile: config.wholesale.image.cover_image,
      config: config.wholesale,
      link: {
        label: config.wholesale.text_button,
        value: makeUrl(pathname, `ventas-mayoreo`),
      },
    });
  }
  if (storeMetadata?.configuration?.videoUrl) {
    items.push({
      video: storeMetadata?.configuration?.videoUrl,
      config: config.welcome,
    });
  }

  const handleClickScroll = (link?: string, elementId?: string) => {
    if (link) {
      if (link.includes("ofertas")) {
        logEvent(MAIN_COVER_EVENTS.SELECT_WEB_PROMO_BANNER);
      } else if (link.includes("ventas-mayoreo")) {
        logEvent(MAIN_COVER_EVENTS.SELECT_WEB_WHOLESALE_BANNER);
      }
      navigate(link, { relative: "path" });
    }
    if (elementId) {
      navigate("todos-los-productos", { relative: "path" });
    }
  };

  const getCoverPreview = (cover: string) => {
    if (!cover) return cover;
    const isBlob = cover.includes("blob:");
    const isAlreadyResized = cover.includes("image-tool-lambda");
    return (isBlob || isAlreadyResized) ? cover : resizeImage(cover, 0, 0, 60);
  };

  return {
    navigate,
    pathname,
    items,
    enterpriseName,
    stepToPause,
    handleClickScroll,
    getCoverPreview,
  };
};
